var _excluded = ["gradient", "rootClassName", "tag"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
//
import * as React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet, gradient } from "../../styles/theme";

/**
 * A GradientWrapper that accepts children
 * Sample Usage:
 * <GradientWrapper tag={Box} flexDirection="column"> Content here <GradientWrapper>
 */

var GradientWrapper = function GradientWrapper(_ref) {
  var _ref$gradient = _ref.gradient,
    start = _ref$gradient.start,
    end = _ref$gradient.end,
    deg = _ref$gradient.deg,
    rootClassName = _ref.rootClassName,
    Tag = _ref.tag,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Tag, _extends({}, css(rootClassName, StyleSheet.create({
    gradientBg: {
      backgroundImage: "linear-gradient(".concat(deg || 90, "deg, ").concat(start, ", ").concat(end, ")")
    }
  }).gradientBg), rest));
};

// Explicity declare the default props for documentation purpose
GradientWrapper.defaultProps = {
  gradient: gradient.coursera,
  tag: 'div'
};
GradientWrapper.propTypes = {
  rootClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  gradient: PropTypes.shape({
    start: PropTypes.string.isRequired,
    end: PropTypes.string.isRequired,
    deg: PropTypes.number.isRequired
  }).isRequired,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
};
export default GradientWrapper;